/*
 * Proprietary and confidential | 2026 | SoundTalks NV
 */

import { fromJS } from 'immutable';
import * as constants from 'data/constants/admin/companies';
import LoadingProgress from 'data/utils/reducers/loading';
import Pagination from 'data/utils/reducers/pagination';

export const itemsPagination = new Pagination('adminCompanies');
export const loadingProgress = new LoadingProgress('adminCompany');
export const listLoadingProgress = new LoadingProgress('adminCompaniesList');
export const createLoadingProgress = new LoadingProgress('adminCompanyCreate');
export const updateLoadingProgress = new LoadingProgress('adminCompanyUpdate');
export const addSiteLoadingProgress = new LoadingProgress('adminCompanyAddSite');
export const removeSiteLoadingProgress = new LoadingProgress('adminCompanyRemoveSite');

const mergeData = (state: any, payload: any) =>
  state.withMutations((newState: any) => {
    const {
      entities: { companies },
    } = payload;

    if (companies) {
      newState.mergeIn(['entities'], fromJS(companies));
    }
  });

const loadList = (state: any, action: any) =>
  state.withMutations((newState: any) => {
    const { result, perPage, total } = action.payload;
    mergeData(newState, action.payload);
    itemsPagination.set(newState, total, perPage, fromJS(result));
    listLoadingProgress.setLoaded(newState);
  });

const loadEntity = (state: any, action: any) =>
  state.withMutations((newState: any) => {
    const resultId = String(action.payload.result);
    const companyFromPayload =
      action.payload?.entities?.companies?.[resultId] ?? action.payload?.entities?.companies?.[action.payload.result];

    if (companyFromPayload) {
      newState.setIn(['entities', resultId], fromJS(companyFromPayload));
    } else {
      mergeData(newState, action.payload);
    }

    newState.set('currentCompanyId', action.payload.result);
    loadingProgress.setLoaded(newState);
  });

const clear = (state: any) =>
  state.withMutations((newState: any) => {
    listLoadingProgress.clear(newState);
    itemsPagination.clear(newState);
    loadingProgress.clear(newState);
    createLoadingProgress.clear(newState);
    updateLoadingProgress.clear(newState);
    addSiteLoadingProgress.clear(newState);
    removeSiteLoadingProgress.clear(newState);
  });

const clearSingle = (state: any) =>
  state.withMutations((newState: any) => {
    newState.delete('currentCompanyId');
    loadingProgress.clear(newState);
    updateLoadingProgress.clear(newState);
    addSiteLoadingProgress.clear(newState);
    removeSiteLoadingProgress.clear(newState);
  });

const initialState = fromJS({
  entities: {},
});

export default (state = initialState, action: any) => {
  switch (action.type) {
    case constants.LIST_LOAD_START:
      return listLoadingProgress.setLoading(state);
    case constants.LIST_LOAD_FAILED:
      return listLoadingProgress.setLoadFailed(state);
    case constants.LIST_LOAD_SUCCESS:
      return loadList(state, action);
    case constants.LOAD_START:
      return loadingProgress.setLoading(state);
    case constants.LOAD_FAILED:
      return loadingProgress.setLoadFailed(state);
    case constants.LOAD_SUCCESS:
      return loadEntity(state, action);
    case constants.CREATE_START:
      return createLoadingProgress.setLoading(state);
    case constants.CREATE_FAILED:
      return createLoadingProgress.setLoadFailed(state);
    case constants.CREATE_SUCCESS:
      return state.withMutations((newState: any) => {
        mergeData(newState, action.payload);
        createLoadingProgress.setLoaded(newState);
      });
    case constants.UPDATE_START:
      return updateLoadingProgress.setLoading(state);
    case constants.UPDATE_FAILED:
      return updateLoadingProgress.setLoadFailed(state);
    case constants.UPDATE_SUCCESS:
      return state.withMutations((newState: any) => {
        mergeData(newState, action.payload);
        updateLoadingProgress.setLoaded(newState);
      });
    case constants.ADD_SITE_START:
      return addSiteLoadingProgress.setLoading(state);
    case constants.ADD_SITE_FAILED:
      return addSiteLoadingProgress.setLoadFailed(state);
    case constants.ADD_SITE_SUCCESS:
      return addSiteLoadingProgress.setLoaded(state);
    case constants.REMOVE_SITE_START:
      return removeSiteLoadingProgress.setLoading(state);
    case constants.REMOVE_SITE_FAILED:
      return removeSiteLoadingProgress.setLoadFailed(state);
    case constants.REMOVE_SITE_SUCCESS:
      return removeSiteLoadingProgress.setLoaded(state);
    case constants.CLEAR:
      return clear(state);
    case constants.CLEAR_SINGLE:
      return clearSingle(state);
    default:
      return state;
  }
};
